<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Packages</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog1" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="headline">View package Details</span>
          </v-card-title>
          <div v-if="editedItem.viewData">
            <v-data-table
              :headers="headers2"
              :items="editedItem.viewData.package_detail"
              :search="search"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.service_name }}</td>
                <td class="text-xs-center">
                  {{ props.item.max_limit ? props.item.max_limit : "N/A" }}
                </td>
                <td class="text-xs-center">{{ props.item.is_allowed ? "Allowed" : "N/A" }}</td>
              </template>
              <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                <v-alert :value="true" color="error" icon="warning">
                  Sorry, nothing to display here :(
                </v-alert>
              </template>
            </v-data-table>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close1">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create New</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="Rules.required"
                    label="Package Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                    v-model="editedItem.is_active"
                    :items="this.activeStatus"
                    item-text="name"
                    item-value="id"
                    :rules="Rules.required"
                    label="Active Status"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div v-if="indexData.packages">
      <v-data-table
        :headers="headers"
        :items="indexData.packages.data"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">
            {{ props.item.is_active ? "Active" : "In-active" }}
          </td>
          <td class="text-xs-center">{{ props.item.created_by }}</td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="viewItem(props.item)">
              visibility
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
          </td>
        </template>
        <template v-slot:no-data>
          <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          <v-alert :value="true" color="error" icon="warning">
            Sorry, nothing to display here :(
          </v-alert>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialog1: false,
    search: "",
    apiUrl: "package",
    headers: [
      {
        text: "ID",
        align: "center",
        value: "id",
      },
      {
        text: "Package Name",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Active Status",
        align: "center",
        sortable: false,
        value: "is_active",
      },
      {
        text: "Created By",
        align: "center",
        sortable: false,
        value: "created_by",
      },
      {
        text: "Created At",
        align: "center",
        sortable: false,
        value: "created_date",
      },

      { text: "Actions", align: "center", value: "actions" },
    ],
    headers2: [
      {
        text: "ID",
        align: "center",
        value: "id",
      },
      {
        text: "Service Name",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Max Limit",
        align: "center",
        sortable: false,
        value: "is_active",
      },
      {
        text: "Is Allowed",
        align: "center",
        sortable: false,
        value: "is_allowed",
      },
    ],
    activeStatus: [
      { name: "Active", id: 1 },
      { name: "In-active", id: 0 },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      is_active: "",
      viewData: null,
    },
    defaultItem: {
      name: "",
      is_active: "",
      viewData: null,
    },
    Rules: {
      required: [(v) => !!v || "This filed is required"],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Package" : "Edit Package";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    viewItem(item) {
      this.editedIndex = this.indexData.packages.data.indexOf(item);
      this.editedItem.viewData = Object.assign({}, item);
      this.dialog1 = true;
    },

    editItem(item) {
      this.editedIndex = this.indexData.packages.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.packages.data.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.packages.data.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    close1() {
      this.dialog1 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      }
      this.close();
    },
  },
};
</script>
